export * from './types';
import { ViewPager } from './ViewPager';
export default ViewPager;
